import { PRIZE_SLOT_INK_CHOICES, resolvePrizeSlotInk } from '@/lib/prize-product';

type Props = {
  value: string;
  onChange: (next: string) => void;
  id?: string;
  'aria-label'?: string;
};

/**
 * Name / number / name-and-number ink: White or Black only.
 * Same radio wording/style as the logo-slot White / Black choices.
 * Stores the existing hex contract (`#FFFFFF` / `#000000`).
 */
export function PrizeInkField({ value, onChange, id, 'aria-label': ariaLabel }: Props) {
  const current = resolvePrizeSlotInk(value);
  const group = id || 'prize-ink';
  return (
    <div className="flex flex-wrap items-center gap-2" aria-label={ariaLabel || 'Font color'}>
      {PRIZE_SLOT_INK_CHOICES.map((c) => (
        <label
          key={c.value}
          className="flex cursor-pointer items-center gap-1 whitespace-nowrap text-[11px] text-muted"
        >
          <input
            type="radio"
            name={group}
            checked={current === c.value}
            onChange={() => onChange(c.value)}
          />
          {c.label}
        </label>
      ))}
    </div>
  );
}
